import React from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { JobTrackerListingType } from "../../../redux/listing/listingTypes";
import { TableHeader } from "../../commons";
import JobTableData from "../../JobListing/JobTable/JobTableData";
import { GovtOfficerJobsListType, LoginResponseType } from "../../../redux/auth/authTypes";
import JobPendingApprovalTableData from "../../JobListing/JobTable/JobPendingApprovalTableData";

type AppProps = {
  data:  JobTrackerListingType[] | GovtOfficerJobsListType[];
  headers: TableHeadersType[];
  fetching: boolean;
  getJobId?: any;
  handleSetJobsData?: (data: any, type: string) => void;
  handleToggleProgressCommentsModal?: () => void;
  getShareJobId?: (id: number) => void;
  handleToggleShareJobModal?: () => void;
  handleToggleLinkUploadModal?: () => void;
  isAdminReport?: boolean;
  isSuperAdmin?: boolean;
  type?: string;
  tab?: string;
  shareJobList?: boolean;
  jobApprovalPending?: boolean;
  isSentForJobClosureActionPresent?: boolean;
  handleSentJobForClosuring?: (data: any) => void;
  handleApproveAndSendModal?: (data: any) => void;
  handleChecklistModal?: (data: JobTrackerListingType) => void;
  loginData?: LoginResponseType | undefined;
  isSingleCheckListPresent?:boolean;
  commentDueTomorrow?:boolean;
};

const JobProgressTable = ({
  data,
  getJobId,
  headers,
  fetching,
  isAdminReport,
  isSuperAdmin,
  type,
  shareJobList,
  loginData,
  handleChecklistModal,
  getShareJobId,
  handleToggleShareJobModal,
  handleSetJobsData,
  handleToggleProgressCommentsModal,
  handleToggleLinkUploadModal,
  jobApprovalPending,
  handleSentJobForClosuring,
  tab,
  handleApproveAndSendModal,
  isSentForJobClosureActionPresent,
  isSingleCheckListPresent,
  commentDueTomorrow
}: AppProps) => {
  return (
    <>
      <div className="jobsType" style={{ overflowX: "scroll", width: "100%" }}>
        <table className="table table-bordered thead-light">
          <thead className="text-start sticky-table-header">
            <TableHeader tableHeader={headers} />
          </thead>
          <tbody>
            {tab === "jobsPendingApproval" ? (
              <JobPendingApprovalTableData
                jobData={data}
                getJobId={getJobId}
                type={type}
                handleChecklistModal={handleChecklistModal}
                shareJobList={shareJobList}
                tableHeader={headers}
                handleSetJobsData={handleSetJobsData}
                handleToggleProgressCommentsModal={
                  handleToggleProgressCommentsModal
                }
                handleToggleLinkUploadModal={handleToggleLinkUploadModal}
                isAdminReport={isAdminReport}
                isSuperAdmin={isSuperAdmin}
                getShareJobId={getShareJobId}
                handleToggleShareJobModal={handleToggleShareJobModal}
                jobApprovalPending={jobApprovalPending}
                handleSentJobForClosuring={handleSentJobForClosuring}
                loginData={loginData}
                tab={tab}
                handleApproveAndSendModal={handleApproveAndSendModal}
              />
            ) : (
              <JobTableData
                jobData={data}
                getJobId={getJobId}
                type={type}
                handleChecklistModal={handleChecklistModal}
                shareJobList={shareJobList}
                tableHeader={headers}
                handleSetJobsData={handleSetJobsData}
                handleToggleProgressCommentsModal={
                  handleToggleProgressCommentsModal
                }
                handleToggleLinkUploadModal={handleToggleLinkUploadModal}
                isAdminReport={isAdminReport}
                isSuperAdmin={isSuperAdmin}
                getShareJobId={getShareJobId}
                handleToggleShareJobModal={handleToggleShareJobModal}
                jobApprovalPending={jobApprovalPending}
                handleSentJobForClosuring={handleSentJobForClosuring}
                loginData={loginData}
                tab={tab}
                handleApproveAndSendModal={handleApproveAndSendModal}
                isSentForJobClosureActionPresent={
                  isSentForJobClosureActionPresent
                }
                isSingleCheckListPresent={isSingleCheckListPresent}
                commentDueTomorrow={commentDueTomorrow}
              />
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default JobProgressTable;
